import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError, api, type Me } from "./api";

// The signed-in user (null when signed out). Shared by every page through the query cache.
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await api<Me>("/auth/me");
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}

export function useSetMe() {
  const qc = useQueryClient();
  return (me: Me | null) => qc.setQueryData(["me"], me);
}
